'use client'

import React from 'react'
import styles from './styles.module.css'
import { processStrapiTextTags } from '@/components/StrapiContentRenderer'
import { convertRichTextToHTML } from '@/components/StrapiContentRenderer'

interface TwoColumnsTitleDescription {
  id?: number
  block_h4?: string | any
  block_description?: string | any
}

interface TwoColumnsH4Data {
  two_columns_title_description?: Array<TwoColumnsTitleDescription>
}

interface TwoColumnsH4Props {
  data: TwoColumnsH4Data
}

const processText = (text: string | any): string => {
  if (!text) return ''
  
  if (typeof text === 'string') {
    // Обрабатываем переносы строк: \n\n = новый абзац, \n = перенос
    let processed = text.replace(/\n\n/g, '</p><p>').replace(/\n/g, '<br>')
    if (processed && !processed.startsWith('<p>')) {
      processed = `<p>${processed}</p>`
    }
    return processStrapiTextTags(processed)
  }
  
  if (Array.isArray(text)) {
    const html = convertRichTextToHTML(text)
    return processStrapiTextTags(html)
  }
  
  return processStrapiTextTags(String(text))
}

const TwoColumnsH4: React.FC<TwoColumnsH4Props> = ({ data }) => {
  const items = data.two_columns_title_description?.filter(
    item => item.block_h4 || item.block_description
  ) || []

  if (items.length === 0) {
    return null
  }

  return (
    <section className={styles.twoColumnsH4}>
      {items.map((item, index) => {
        const h4 = processText(item.block_h4)
        const description = processText(item.block_description)

        if (!h4 && !description) return null

        return (
          <div key={item.id || index} className={styles.block}>
            {h4 && (
              <h4 
                className={styles.blockH4}
                dangerouslySetInnerHTML={{ __html: h4 }}
              />
            )}
            {description && (
              <div 
                className={styles.blockDescription}
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
          </div>
        )
      })}
    </section>
  )
}

TwoColumnsH4.displayName = 'TwoColumnsH4'

export default TwoColumnsH4

